import React from "react";
import { PRICING } from "../lib/constants";

export const Pricing = () => {
  return (
    <section
      data-testid="pricing-section"
      id="precario"
      className="relative pt-28 pb-14 md:pt-32 md:pb-16 bg-[#0E2452] border-y border-[#2F568F]"
    >
      <div className="w-full px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          {/* Left: heading */}
          <div className="lg:col-span-4">
            <span data-testid="pricing-label" className="section-label">
              // Preçário
            </span>
            <h2
              data-testid="pricing-title"
              className="heading-lg text-white mt-3 mb-4"
            >
              Transparência <span className="text-[#5FA8FF]">total.</span>
              <br />
              Sem surpresas.
            </h2>
            <p className="text-[#A1A1AA] font-body text-sm leading-relaxed mb-6">
              Lista dos serviços rápidos prestados na nossa oficina. Para uma
              estimativa personalizada ao seu veículo, peça-nos um orçamento.
            </p>

            <div
              data-testid="pricing-feature-image"
              className="relative overflow-hidden rounded-2xl border border-[#2F568F] aspect-[4/3]"
            >
              <img
                src="https://customer-assets.emergentagent.com/job_tire-commerce/artifacts/tqfzjnmn_image.png"
                alt="Técnico Global Pneus a montar pneu desportivo"
                className="absolute inset-0 w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0E2452]/80 via-transparent to-transparent pointer-events-none" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="text-[10px] uppercase tracking-[0.3em] text-[#FF5A00] font-display font-bold mb-1">
                  Trabalho cuidado
                </div>
                <div className="font-display font-bold uppercase text-white text-xl tracking-wide leading-none">
                  Mãos que conhecem cada pneu
                </div>
              </div>
            </div>
          </div>

          {/* Right: services list */}
          <div className="lg:col-span-8">
            <div className="rounded-2xl overflow-hidden border border-[#2F568F] bg-[#163A6D]">
              <div className="grid grid-cols-12 px-5 py-3 border-b border-[#2F568F] bg-[#0E2452]">
                <div className="col-span-12 font-display text-xs uppercase tracking-widest text-[#A1A1AA]">
                  Serviços rápidos
                </div>
              </div>

              {PRICING.map((row, idx) => (
                <div
                  key={row.service}
                  data-testid={`pricing-row-service-${idx}`}
                  className="grid grid-cols-12 px-5 py-3.5 border-b border-[#2F568F] last:border-b-0 hover:bg-[#1A4380] transition-colors"
                >
                  <div className="col-span-12 font-body text-sm text-white flex items-center gap-3">
                    <span className="text-[#FF5A00] font-display font-bold text-xs w-6 flex-shrink-0">
                      {String(idx + 1).padStart(2, "0")}
                    </span>
                    <span>{row.service}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
